<template>
  <div class="animated fadeIn step-container">
    <div class="row">
      <div class="col-md-8 offset-md-2 alert-container-padding-zero">
        <alertbar/>
      </div>
    </div>
    <div class="row">
        <div class="col-md-8 offset-md-2 step-body">
          <h4 class="step-header">{{$t('message.clinic_info.title')}}</h4>
          <div class="row">
            <div class="col-12">
              <h6>{{$t('message.clinic_info.clinic_name')}}</h6>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="clinic-name-th">{{$t('message.clinic_info.clinic_name_th')}}</label>
                <input type="text" class="form-control" id="clinic-name-th" :placeholder="$t('message.clinic_info.clinic_name_th')" v-model="clinic.th.clinic_name">
              </div>
            </div>

            <div class="col-12">
              <div class="form-group">
                <label for="clinic-name-en">{{$t('message.clinic_info.clinic_name_en')}}</label>
                <input type="text" class="form-control" id="clinic-name-en" :placeholder="$t('message.clinic_info.clinic_name_en')" v-model="clinic.en.clinic_name">
              </div>
            </div>
          </div>

          <div class="form-divider"></div>

          <div class="row">
            <div class="col-12">
              <h6>{{$t('message.clinic_info.clinic_detail')}}</h6>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="clinic-detail-th">{{$t('message.clinic_info.clinic_detail_th')}}</label>
                <input type="text" class="form-control" id="clinic-detail-th" :placeholder="$t('message.clinic_info.clinic_detail_th')" v-model="clinic.th.detail">
              </div>
            </div>

            <div class="col-12">
              <div class="form-group">
                <label for="clinic-detail-en">{{$t('message.clinic_info.clinic_detail_en')}}</label>
                <input type="text" class="form-control" id="clinic-detail-en" :placeholder="$t('message.clinic_info.clinic_detail_en')" v-model="clinic.en.detail">
              </div>
            </div>
          </div>

          <div class="form-divider"></div>

          <div class="row">
            <div class="col-12">
              <h6>{{$t('message.clinic_info.clinic_logo')}}</h6>
            </div>
            <div class="col-12">
              <drop-zone class="crop-profile-image-dropzone" :class="{'profile-image-active': isProfileImage}" @fileChange="profileImageFileChange" :placeholder="profileImagePlaceholder"></drop-zone>
              <img class="crop-profile-image" ref='crop-profile-image' :src="profile_image_src" />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <h6>{{$t('message.clinic_info.clinic_albums')}}</h6>
            </div>
            <div class="col-12">
              <div id='alblum-wrapper'>
              <div class='image-in-alblum-wrapper' v-for="img in clinic.images" v-if="!img.is_active" :key="img.id">
                  <i class="fa fa-2x fa-times remove-image-from-alblum" aria-hidden="true" @click="removeImageFromAlblum(img.id)"></i>
                  <img class='image-in-alblum' :src="img.file_thumb" />
              </div>
              <vue-core-image-upload
                :class="['btn', 'btn-primary', 'btn-upload-image']"
                :crop="false"
                :max-file-size="5242880"
                input-of-file="image"
                @imageuploaded="imageAlblumUploaded"
                :url="$APP_CONFIG.api.admin.upload_clinicme_alblum()" >
                  <i title="remove image" 
                    class="fa fa-2x fa-plus plus-image" 
                    aria-hidden="true"></i>
              </vue-core-image-upload>
              </div>
            </div>
          </div>

          <div class="form-divider"></div>
          <div class="row">
            <div class="col-12">
              <h6>{{$t('message.clinic_info.clinic_info')}}</h6>
            </div>
            <div class="form-group col-12">
              <label for="bio-th">{{$t('message.clinic_info.clinic_info_th')}}</label>
              <ckeditor id="bio-th" v-model="clinic.th.info" :config="ckeditorConfig"/>
              <div class="editor-lock"><i aria-hidden="true" class="fa fa-lock menu-lock" v-if="ckeditorConfig.readOnly"></i></div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-12">
              <label for="bio-en">{{$t('message.clinic_info.clinic_info_en')}}</label>
              <ckeditor id="bio-en" v-model="clinic.en.info" :config="ckeditorConfig"/>
              <div class="editor-lock"><i aria-hidden="true" class="fa fa-lock menu-lock" v-if="ckeditorConfig.readOnly"></i></div>
            </div>
          </div>

          <div class="form-divider"></div>

          <div class="row">
            <div class="col-12">
              <h6>{{$t('message.clinic_info.video_links')}}</h6>
            </div>
            <div class="form-group col-12">
              <doctor-array-input :dataset.sync="clinic.th.video_links"
                            @update:dataset="v => clinic.th.video_links = v"
                            :description="$t('message.clinic_info.youtube_link')" />
            </div>
          </div>

          <div class="row">
            <div class="col-12 form-group">
              <button class="btn btn-cancel btn-lg" @click="cancelChange">{{$t('action_message.cancel')}}</button>
              <button class="btn btn-store btn-lg" @click="saveAndContinue">{{$t('action_message.save')}}</button>
              <slot name='loader'></slot>
            </div>
          </div>
        </div>
      </div>

      <!-- Crop Modal -->
    <sweet-modal ref='crop-modal' overlay-theme="dark">
      <div>
        <div class='row'>
          <div class='col-md-12'>
            <vue-croppie 
                ref=croppieRef 
                :enableOrientation="true">
            </vue-croppie>
          </div>
          <div class='col-md-12 form-group'>
            <button class="btn btn-lg btn-close" @click.prevent="cancelCrop">{{$t('action_message.cancel')}}</button>
            <button class="btn btn-lg btn-success" @click.prevent="confirmCrop">{{$t('action_message.ok')}}</button>
          </div>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import Alertbar from '@/components/AlertBar'
import Step from '@/components/StepBar'
import { dropdown as VDropdown } from 'vue-strap'
import VueCoreImageUpload from 'vue-core-image-upload'
import Ckeditor from '@/components/Ckeditor'
import DropZone from '@/components/DropZone'
import { SweetModal } from 'sweet-modal-vue'
import DoctorArrayInput from '@/components/DoctorArrayInput'

export default {
  components: {
    VDropdown,
    Step,
    Alertbar,
    VueCoreImageUpload,
    Ckeditor,
    DropZone,
    SweetModal,
    DoctorArrayInput
  },
  props: {
    clinic: {
      type: Object,
      default: {
        en: {
          video_links: []
        },
        th: {
          video_links: []
        },
        images: []
      },
      required: true
    }
  },
  data () {
    return {
      profile_image_src: '/static/img/no_profile_image.png',
      ckeditorConfig: {
        toolbar: [
          { name: 'basicstyles', items: ['Bold', 'Italic'] },
          { name: 'paragraph', items: ['BulletedList'] },
          { name: 'styles', items: ['Format'] }
        ],
        readOnly: !this.$guser.isPremiumAccount()
      },
      profileImagePlaceholder: `<i class="fa fa-cloud-upload" aria-hidden="true"> ${this.$t('message.clinic_info.clinic_picture_ph')}</i>`
    }
  },
  computed: {
    isProfileImage () {
      return self.profile_image_src !== null
    }
  },
  methods: {
    saveAndContinue () {
      // work with sync modifier
      this.$emit('update:clinic', this.clinic)

      // finish step
      this.$emit('finishStep', {
        th: {
          clinic_name: this.clinic.th.clinic_name,
          info: this.clinic.th.info,
          detail: this.clinic.th.detail,
          video_links: (this.clinic.th.video_links) ? this.clinic.th.video_links : []
        },
        en: {
          clinic_name: this.clinic.en.clinic_name,
          info: this.clinic.en.info,
          detail: this.clinic.en.detail,
          video_links: (this.clinic.en.video_links) ? this.clinic.en.video_links : []
        }
      })
    },
    cancelChange () {
      this.$emit('cancelChange')
    },
    async removeImageFromAlblum (imgId) {
      if (imgId) {
        if (await this.$confirm(this.$t('action_message.are_you_sure'))) {
          let self = this
          this.$http.delete(this.$APP_CONFIG.api.admin.upload_clinicme_alblum_id(imgId), { credentials: true }).then(res => {
            self.refreshDoctor()
          })
        }
      }
    },
    imageAlblumUploaded () {
      this.refreshDoctor()
    },
    refreshDoctor () {
      var self = this
      this.$http.get(this.$APP_CONFIG.api.admin.clinicme(), { credentials: true }).then(res => {
        var clinic = Object.assign({}, self.clinic, res.body.data)

        if (!this.clinic.th.video_links) {
          this.clinic.th.video_links = []
        }
        if (!this.clinic.en.video_links) {
          this.clinic.en.video_links = []
        }
        self.doctor_profile_th = res.body.data.th
        self.doctor_profile_en = res.body.data.en

        // find active profile image
        if (clinic.images && clinic.images.length > 0) {
          var activeUri = clinic.images.find(img => img.is_active)
          self.profile_image_src = activeUri.file_thumb || '' // TODO default profile image src
        }
        this.$emit('update:clinic', clinic)
      }, errorResponse => {
        console.error(errorResponse)
      })
    },
    profileImageFileChange (file) {
      this.$loadFile(file, (result) => {
        this.$refs.croppieRef.bind({
          url: result
        })
        this.$refs['crop-modal'].open()
      })
    },
    cancelCrop () {
      this.$refs['crop-modal'].close()
    },
    confirmCrop () {
      this.$refs['crop-modal'].close()
      let options = {
        format: 'jpeg'
      }
      this.$refs.croppieRef.result(options, (output) => {
        var formData = new FormData()
        formData.append('image', this.$processB64ToBlob(output))
        this.$http.post(this.$APP_CONFIG.api.admin.upload_clinicme_image(), formData)
        .then(res => {
          this.$refs['crop-profile-image'].src = res.body.data
        })
      })
    }
  },
  mounted () {
    // find active profile image
    if (this.clinic.images && this.clinic.images.length > 0) {
      var activeUri = this.clinic.images.find(img => img.is_active)
      this.profile_image_src = activeUri.file_thumb || '' // TODO default profile image src
    }
  }
}
</script>

<style lang="scss">
@import "../../../assets/base_container";
.gender-select{
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 1rem;
  .form-check {
    margin-bottom: 0px;
  }
  .form-check-inline + .form-check-inline { 
    margin-left: 2.5rem;
  }
}
.g-core-image-corp-container {
    margin-top: 55px;
}

.crop-profile-image-dropzone {
  position: absolute !important;
  border-radius: 100px !important;
}

.crop-profile-image {
    width: 200px;
    height: 200px;
    display: block;
    border-radius: 100px;
    border: dashed 1px #85ace7;
    margin-bottom: 20px;
}

.btn-upload-image {
    border: 1px dashed #85ace7;
    color: #85ace7;
    background-color: transparent;
    width: 100px;
    height: 100px;
}
.btn-upload-image:hover {
    background-color: rgba(133, 172, 231, 0.5);
}
.plus-image {
    margin-top: 25px;
}
#alblum-wrapper {
    display: flex;
    justify-content: flext-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.image-in-alblum {
    width: 100px;
    height: 100px;
    border: 1px dashed #85ace7;
    margin-right: 0.5em;
    margin-bottom: 10px;
}
.image-in-alblum-wrapper {
    display: inline-block;
}
.image-in-alblum-wrapper:hover .image-in-alblum {
    border: 1px solid #85ace7;
}
.image-in-alblum-wrapper:hover .remove-image-from-alblum {
    display: block;
}
.remove-image-from-alblum {
    color: rgba(200, 0, 0, 0.9); 
    position: absolute;
    margin-left: 75px;
    margin-top: 0px;
    display: none;
    opacity: 0.8;
}

.profile-image-active {
  color: transparent !important;
}

.profile-image-active:hover {
  color: #85ace7 !important;
}

.editor-lock{
  position: absolute;
  font-size: 48px;
  top: 35%;
  left: 45%;
  color: #aaa;
}

</style>



// WEBPACK FOOTER //
// General.vue?f4217d0e